export default {"src":"/_next/static/media/bowling.8db7652a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};